import React, { useEffect } from "react";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import "../Team/Team.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { GiCalculator } from "react-icons/gi";

const teamMembers = [
  {
    name: "XYZ Arora",
    role: "Chartered Accountant",
    img: "https://img.freepik.com/free-photo/portrait-smiling-charming-young-man-grey-t-shirt-standing-against-plain-background_23-2148213406.jpg?t=st=1736935520~exp=1736939120~hmac=58ee03ad71be0930a7e567b3f3331dc6ee299d44216a63d80a5d9f0c08ed7c44&w=740",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
    },
  },
  {
    name: "XYZ Mehta",
    role: "Tax Consultant",
    img: "https://img.freepik.com/free-photo/brunette-businesswoman-posing_23-2148142767.jpg?t=st=1736935651~exp=1736939251~hmac=32b7855e8a6ab0dd889d599574c62bfce450663035885c6aae1d12d5ddf3f714&w=740",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
    },
  },
  {
    name: "XYZ Kapoor",
    role: "Corporate Tax Advisor",
    img: "https://img.freepik.com/free-photo/medium-shot-man-working-as-lawyer_23-2151054078.jpg?t=st=1736935572~exp=1736939172~hmac=188bb6ea502be5345f6a6db15f1ae3f5bf7b696c09ba430fac608c25e2f034cb&w=740",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
    },
  },
  {
    name: "XYZ Iyer",
    role: "Financial Consultant",
    img: "https://img.freepik.com/free-photo/modern-businesswoman-with-book_23-2147985475.jpg?t=st=1736935621~exp=1736939221~hmac=0b3feeb7f8533b9d466c542330efec5ecb98993f9e30342be474d437cb05eaff&w=740",
    socials: {
      facebook: "#",
      instagram: "#",
      twitter: "#",
    },
  },
];

const Team = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Animation for the main heading
    gsap.to(".main-heading-pct", {
      scale: 2,
      duration: 2,
      ease: "power2.out",
      delay: 1.5,
      scrollTrigger: {
        trigger: ".full-team",
        start: "top center", // Start when the service section reaches the center
        end: "bottom center", // End at the bottom center
        scrub: 1,
        toggleActions: "restart reverse restart reverse", // Ensures reverse effect when scrolling up
      },
    });
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  return (
    <>
      <div className="full-team">
        <div className="decorated-heading-pct">
          <GiCalculator className="react-icon-pct" />
        </div>
        <h1 className="main-heading-pct">Meet Our Team</h1>
        <p className="description-pct">
          At CA & Associates, our team of dedicated legal professionals brings a
          wealth of expertise and passion to every case. With years of
          experience across diverse fields of law, we are committed to
          delivering exceptional legal solutions tailored to our clients' unique
          needs.
        </p>
        <div className="main-t">
          {teamMembers.map((member, index) => (
            <div className="profile-card-t" key={index}>
              <div className="img-t">
                <img src={member.img} alt={`${member.name}`} />
              </div>
              <div className="caption-t">
                <h3>{member.name}</h3>
                <p>{member.role}</p>
                <div className="social-links-t">
                  <a
                    href={member.socials.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook />
                  </a>
                  <a
                    href={member.socials.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href={member.socials.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Team;
